import type React from 'react';

import { useGetResources } from '@hooks/useGetResources';
import { LenkeType, type Lenke } from '@src/types/minhelseentities';
import { sporAapningAvVerktoy } from '@utils/amplitude-utils';

import AnchorLink from '@helsenorge/designsystem-react/components/AnchorLink';

interface Props {
  verktoyLenker: Array<Lenke>;
  verktoyNavn: string;
  interntVerktoy: boolean;
}

const OpenUtvidetInfoLink = ({ verktoyLenker, verktoyNavn, interntVerktoy }: Props): React.JSX.Element => {
  const resources = useGetResources();

  const utvidetInfoLenke = verktoyLenker !== undefined ? verktoyLenker.find(v => v.LenkeType === LenkeType.Utvidetinformasjon) : undefined;

  return (
    <div>
      {utvidetInfoLenke && utvidetInfoLenke.Url && (
        <>
          <div>
            <AnchorLink
              onClick={(): void => sporAapningAvVerktoy(verktoyNavn, LenkeType.Standard, interntVerktoy)}
              href={utvidetInfoLenke.Url}
              target={'_blank'}
            >
              {resources?.utvidetLenke_anchorLink_text}
            </AnchorLink>
          </div>
        </>
      )}
    </div>
  );
};

export default OpenUtvidetInfoLink;
